import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const H3Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "H3",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.68 29.99a2 2 0 0 0 2-2v-10h9.33v10a2 2 0 1 0 4 0V4.01a2 2 0 1 0-4 0v10H4.67v-10a2 2 0 1 0-4 0V28a2 2 0 0 0 2 2h.01ZM20.67 4.01a2 2 0 0 0 2 2h4.66v2.66h-4.66a2 2 0 1 0 0 4h4.66v2.66h-4.66a2 2 0 1 0 0 4h6.67a2 2 0 0 0 2-2V4.01c0-1.11-.89-2.01-2-2.01h-6.67a2 2 0 0 0-2 2s0 .01 0 .01"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m27.45 9.2 3.99-6.8v-.12h-9.79V4.5h6.18l-3.97 6.65v.05h2.21c2.26 0 3.58 1.36 3.58 3.18 0 1.95-1.41 3.18-3.6 3.18-1.78 0-3.31-.69-4.6-1.73h-.05v2.59c.61.34 2.44 1.35 4.85 1.35 3.34 0 5.75-2.46 5.75-5.52 0-2.56-1.76-4.73-4.55-5.05M16 2.29c-.63 0-1.14.51-1.14 1.14v11.43H2.29V3.43a1.14 1.14 0 1 0-2.28 0v25.14a1.14 1.14 0 1 0 2.28 0V17.14h12.57v11.43a1.14 1.14 0 1 0 2.28 0V3.43c0-.63-.51-1.14-1.14-1.14"
      })
    })
  }));
};